import { useState } from "react";
import Indentification from "../../../elements/Indentification";
import { useDebounce } from "../../../../hooks/useDebounce";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { reportEnquiryList } from "../../../../services/enquiryService";
import LimitSelect from "../../../elements/LimitSelect";
import { handleFilterChange } from "../../../../helpers";
import Search from "../../../form/Search";
import Table from "../../../elements/table/Table";
import EnquiryDetailsModal from "../../../../pages/front/modules/enquiry/EnquiryDetailModal";
import { useOrganization } from "../../../../context/OrganizationContext";
import { useTranslation } from "react-i18next";

const Enquerylist = () => {
  const { t } = useTranslation();
  const [selectedItems, setSelectedItems] = useState([]);
  const [detailsModal, setDetailsModal] = useState({
    isOpen: false,
    data: null,
  });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const { selectedOrganization } = useOrganization();

  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt", // Sort by newest first
  });

  // Fetch enquiry data
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["enquiry", filters, search, selectedOrganization],
    queryFn: async () => {
      const res = await reportEnquiryList({
        ...filters,
        ...(search && { keyword: search }),
        type: "enquiry",
        organization: selectedOrganization,
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
    enabled: !!selectedOrganization,
  });

  // Table header configuration
  const tableHeadData = [
    {
      _id: 1,
      name: t("User Name"),
      align: "left",
    },
    {
      _id: 2,
      name: t("User Email"),
      align: "left",
    },
    {
      _id: 3,
      name: t("Message"),
      align: "left",
    },
    // {
    //   _id: 5,
    //   name: "Submitted",
    //   align: "left",
    // },
    {
      _id: 4,
      name: t("Action"),
      align: "left",
    },
  ];

  // Table data mapping
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[200px]",
          data: (
            <div className="flex items-center gap-2">
              <div className="flex items-start -space-x-4">
                <Indentification
                  className={"shadow-lg bg-transparent"}
                  type="circle"
                  size="md"
                  image={item?.userData?.image && item?.userData?.image?.url}
                  defaultClass={"!bg-primary/10 !text-primary"}
                />
              </div>
              <div className="!font-semibold">{item?.name}</div>
            </div>
            // <div className="space-y-1">
            //   <div className="font-semibold text-gray-800">{userName}</div>
            // </div>
          ),
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[200px]",
          data: (
            <div className="space-y-1">
              <div className="text-sm text-gray-600">{item?.email}</div>
            </div>
          ),
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[250px]",
          data: (
            <div className="text-sm text-gray-700">
              <p className="line-clamp-2">{item?.message}</p>
            </div>
          ),
        },
        {
          _id: "action",
          type: "action",
          align: "left",
          cellClass: "w-[10%]",
          actionData: [
            {
              _id: "details",
              name: t("View Details"),
              icon: "fa-regular fa-eye",
              onClick: () => {
                setDetailsModal({ isOpen: true, data: item });
              },
              standout: false,
            },
          ],
        },
      ],
    };
  });

  // Bulk action options
  const options = [
    {
      id: "bulkDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "Delete Selected",
    },
  ];

  return (
    <>
      <div className="space-y-4 px-0 lg:px-5">
        {/* Filters and Search */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {/* <div className="text-sm text-gray-600">
              Total Enquiries:{" "}
              <span className="font-semibold">
                {data?.metadata?.totalDocs || 0}
              </span>
            </div> */}
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <div className="w-full md:w-36">
              <LimitSelect
                value={filters?.limit}
                allValue={data?.metadata?.totalDocs}
                onChange={(val) => handleFilterChange("limit", val, setFilters)}
              />
            </div>
            <div className="w-full md:w-72">
              <Search
                placeholder={t("Search here")}
                search={(val) => {
                  setKeyword(val);
                  handleFilterChange("page", 1, setFilters);
                }}
              />
            </div>
            {/* {selectedItems?.length > 0 && (
              <div className="flex items-center gap-2">
                <ActionBar options={options} onChange={actionHandler} />
                <span className="flex items-center rounded-full bg-secondary text-surface-01 text-xs px-3 py-1 gap-2">
                  {selectedItems?.length} Selected
                  <button
                    onClick={() => setSelectedItems([])}
                    type="button"
                    className="cursor-pointer hover:text-red-300"
                  >
                    <i className="fa-fw fa-light fa-xmark"></i>
                  </button>
                </span>
              </div>
            )} */}
          </div>
        </div>

        {/* Table */}
        <Table
          tableHeadData={tableHeadData}
          tableData={tableData}
          isLoder={isLoading}
          pageCount={data?.metadata?.totalPages}
          currentPage={filters?.page}
          onPageChange={(val) => {
            handleFilterChange("page", val, setFilters);
            setSelectedItems([]);
          }}
          isFetching={isFetching}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          tableActionDropdownContainer="!w-48"
          emptyStateTitle="No Enquiries Found"
          emptyStateDescription="No customer enquiries have been submitted yet."
        />
      </div>

      {/* Details Modal */}
      <EnquiryDetailsModal
        isOpen={detailsModal?.isOpen}
        onClose={() => setDetailsModal({ isOpen: false, data: null })}
        data={detailsModal?.data}
      />
    </>
  );
};

export default Enquerylist;
